import { z } from 'zod';
export const zTrainingExperience = z.enum([
    '<1 Year',
    '1-2 Years',
    '2-5 Years',
    '3+ Years',
]);
//# sourceMappingURL=commands.js.map